export default class Floor {
  id: string
  name: string
  constructor (id: string, displayName: string) {
    this.id = id
    this.name = displayName
  }
}
